import * as URL from "../url.helper";

import { post } from "../api.helper";

export const callGetGSTINDetails = data => post(URL.GET_GSTIN_DETAIL, data);
export const callGetPanDetails = data => post(URL.GET_PAN_DETAIL, data, {skipInterceptor: true});
export const callGetCommercialDetails = data => post(URL.GET_COMMERCIAL_PAN, data);
export const callCheckUdyamNumber = data => post(URL.CHECK_UDYAM_NUMBER, data)
